export const EDIT_STATE = 'EDIT_STATE';
export const VIEW_STATE = 'VIEW_STATE';

export const summernoteOptions = {
    defaultFontName: 'Arial',
    toolbar: [
        ['style', ['bold', 'italic', 'underline']],
        ['alignment', ['ul', 'ol']], ['insert', ['ltr', 'rtl']],
    ],
};
